import React from 'react';

import { Button, ButtonGroup, DateInput, Field, IMessageProps } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { actions } from 'Data/ReduxViewModels/Ags/Project';
import { IDateRange } from 'Data/ReduxViewModels/Ags/Project/types';
import moment from 'moment';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const RunExportSection: React.FC = () => {
  const dispatch = useDispatch();

  const [runExportParams, setRunExportParams] = useState<IDateRange>({
    startDate: '',
    endDate: '',
  });
  const busyState = useSelector((state) => state.agsProjectExport.status?.busyState);
  const processing = useSelector((state) => state.agsProjectExport.pageHeader?.processing);

  let runExportButtonDisabled: boolean = !(runExportParams.startDate && runExportParams.endDate) || processing;
  let endDateMessages: IMessageProps[] = [];

  if (!runExportButtonDisabled && moment(runExportParams.endDate).isBefore(moment(runExportParams.startDate))) {
    runExportButtonDisabled = true;
    endDateMessages.push({
      severity: 'error',
      message: 'Start Date must be after End Date',
    });
  }

  return (
    <ListFieldSection>
      <div className="AgsProjectExportPage-DateFields">
        <Field
          input={<DateInput />}
          label="Start Date"
          name="startDate"
          value={runExportParams.startDate}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setRunExportParams({ ...runExportParams, startDate: event.target.value })
          }
        />
        <Field
          input={<DateInput />}
          label="End Date"
          name="endDate"
          value={runExportParams.endDate}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setRunExportParams({ ...runExportParams, endDate: event.target.value })
          }
          messages={endDateMessages}
        />
      </div>
      <div className="AgsProjectExportPage-RunButton">
        <ButtonGroup>
          <Button
            onClick={() => dispatch(actions.runNewExport(runExportParams))}
            disabled={runExportButtonDisabled}
            loading={busyState}
          >
            Run Export
          </Button>
        </ButtonGroup>
      </div>
    </ListFieldSection>
  );
};

export default RunExportSection;
